import { useRef } from 'react'
import { Dialog } from '@base-ui/react/dialog'
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.styles'
import type { OverlayProps } from '../ResponsiveSheet/overlay.types'
import { useOverlayUnmountFailsafe } from '../ResponsiveSheet/useOverlayUnmountFailsafe'
import { useBlurActiveElementOnOpen } from 'utils/mui-utils'
import * as S from './Sheet.styles'

// Desktop side-sheet on Base UI's Dialog (modal).
function Sheet({
  open,
  onOpenChange,
  title,
  header,
  footer,
  side = 'right',
  contentTestId,
  className,
  children,
}: OverlayProps) {
  const actionsRef = useRef<Dialog.Root.Actions>(null)
  useBlurActiveElementOnOpen(open)
  useOverlayUnmountFailsafe(open, actionsRef)

  return (
    <Dialog.Root
      open={open}
      onOpenChange={onOpenChange}
      actionsRef={actionsRef}
    >
      <Dialog.Portal>
        <S.Backdrop />
        <S.Popup $side={side} data-testid={contentTestId}>
          <VisuallyHidden as={Dialog.Title}>{title}</VisuallyHidden>
          {header}
          <S.Body className={className}>{children}</S.Body>
          {footer}
        </S.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default Sheet
